// TODO: fix this cyclic dependency
// eslint-disable-next-line import/no-cycle
import Authentication from 'Authentication';

/**
 * A class that makes calls to the API.
 */
class API {
  /**
   * The base URL for the API.
   */
  static BASE = `${process.env.REACT_APP_API_BASE}/api/v1/`;

  /**
   * Parses the result of the HTTP response.
   * @param {object} res The HTTP response.
   */
  static parseResponse = (response) => {
    const {ok, status, statusText} = response;

    if (ok) {
      return response.json();
    }

    throw new Error(`${status}: ${statusText}`);
  };

  /**
   * Parses key-value pairs into HTTP request parameters.
   * @param {object} requestParams The object containing the key-value pairs.
   */
  static parseRequestParams = (requestParams) => {
    if (!requestParams || requestParams.length === 0) return '';

    return `?${Object.entries(requestParams)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('&')}`;
  };

  /**
   * Makes a GET request to the API.
   * @param {string} relativeUrl The URL mapping in the API.
   * @param {object} requestParams The URL request parameters.
   */
  static find = async (relativeUrl, requestParams) => {
    const url = API.BASE + relativeUrl + API.parseRequestParams(requestParams);
    const header = await Authentication.getHeader();
    const response = await fetch(url, {
      method: 'get',
      mode: 'cors',
      headers: {
        'Content-type': 'application/json',
        Authorization: header,
      },
    });

    return API.parseResponse(response);
  };

  /**
   * Makes a PUT or POST request to the API.
   * @param {string} relativeUrl The URL mapping in the API.
   * @param {object} data The data to PUT or POST.
   * @param {object} requestParams The URL request parameters.
   */
  static save = async (relativeUrl, data, requestParams) => {
    let url = API.BASE + relativeUrl;
    let type;

    if (data.id) {
      type = 'put';
      url += data.id;
    } else if (data[0] && data[0].id) {
      type = 'put';
    } else {
      type = 'post';
    }
    url += API.parseRequestParams(requestParams);

    const header = await Authentication.getHeader();
    const response = await fetch(url, {
      method: type,
      mode: 'cors',
      headers: {
        'Content-type': 'application/json',
        Authorization: header,
      },
      body: JSON.stringify(data),
    });

    return API.parseResponse(response);
  };

  /**
   * Handles saving a media file.
   * @param {string} relativeUrl The URL mapping in the API.
   * @param {object} fileInputElement ?
   */
  static saveMedia = async (relativeUrl, fileInputElement) => {
    const url = API.BASE + relativeUrl;
    const formData = new FormData();

    formData.append('mediaFile', fileInputElement);

    const header = await Authentication.getHeader();
    const response = await fetch(url, {
      method: 'post',
      mode: 'cors',
      headers: {
        Authorization: header,
      },
      body: formData,
    });

    return API.parseResponse(response);
  };

  /**
   * Makes a DELETE request to the API.
   * @param {string} relativeUrl The URL mapping in the API.
   * @param {data} data The data containing the ID to delete.
   */
  static delete = async (relativeUrl, data) => {
    const {id} = data;

    if (!id) {
      throw new Error('No ID provided.');
    }

    const url = API.BASE + relativeUrl + id;
    const header = await Authentication.getHeader();
    const response = await fetch(url, {
      method: 'delete',
      mode: 'cors',
      headers: {
        'Content-type': 'application/json',
        Authorization: header,
      },
    });

    return API.parseResponse(response);
  };

  /**
   * Special POST request?
   * @param {string} relativeUrl The URL mapping in the API.
   * @param {object} requestParams The URL request parameters.
   */
  static rpc = async (relativeUrl, requestParams) => {
    const url = API.BASE + relativeUrl + API.parseRequestParams(requestParams);
    const header = await Authentication.getHeader();
    const response = await fetch(url, {
      method: 'post',
      mode: 'cors',
      headers: {
        'Content-type': 'application/json',
        Authorization: header,
      },
    });

    return API.parseResponse(response);
  };
}

export default API;
